import { useMemo } from 'react';
import { useLanguages } from './useLanguages';

export const useLanguageOptions = () => {
  const languages = useLanguages();

  const languagesOptions = useMemo(
    () =>
      Object.entries(languages).map(([key, lang]) => ({
        label: lang.name,
        value: key,
      })),
    [languages]
  );

  return languagesOptions;
};
